import { sendTracking } from '@helpers/tracking';

export function offerWallPageTracking(
    isWithSmartphone: boolean,
    isPro: boolean,
    isLogged: boolean,
    isConvergence: boolean,
    hasPhoneInCart: boolean,
) {
    const pageTracking = {
        pageCategory: 'Liste_produits_mobile',
        page: `Forfaits_avec_engagement_${isWithSmartphone ? 'avec' : 'sans'}_telephone${isPro ? '_pro' : ''}`,
        marketLine: 'Mobile',
        isB2B: false,
        eCommerceStep: 'Liste_produits',
        variant: {
            configurateurPrix: 'prospect_non_logue',
            ...(isWithSmartphone && { bouton: hasPhoneInCart ? 'Choisir_forfait' : 'Choisir_telephone' }),
        },
    };
    if (isLogged) {
        pageTracking.variant.configurateurPrix = `client_${isConvergence ? '' : 'non_'}eligible_convergence`;
    }
    sendTracking(false, pageTracking);
}

export function sendViewMorePlansTracking(isShowed: boolean) {
    sendTracking(false, {
        action: 'Clic_affichage',
        category: 'Liste_forfait_FSM',
        name: `${isShowed ? 'Derouler' : 'Enrouler'}_forfaits_FSM`,
        eCommerceStep: 'Liste_produits',
    });
}

export function sendUpgradePlanModalViewTracking() {
    sendTracking(false, {
        page: 'Proposition_de_selection_d_un_telephone',
        pageCategory: 'Information',
        marketLine: 'Mobile',
        universe: 'Boutique_mobile',
        journey: 'Acquisition',
    });
}
